import React, { useMemo } from "react";
import { ExtractedArticleInformationType } from "../../types/ExtractedArticleInformationType";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useParams } from "react-router";
import DefaultScannerComponentCameraControlled from "../../DefaultScannerComponentCameraControlled";
import { CreateMoreAddonOrdersModal } from "./CreateMoreAddonOrdersModal/CreateMoreAddonOrdersModal";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import useSearchParamState from "@coworker/apprestructured/src/shared/hooks/useSearchParamState";
import { useAllTaskTypes } from "@coworker/apprestructured/src/task-management/services/useTaskTypes";
import { TaskTypeNames } from "@coworker/apprestructured/src/task-management/constants/TaskTypeNames";

const DefaultScannerPage: React.FC = () => {
  const navigate = useFixaNavigate();
  const { type } = useParams<{ type: string }>();
  const enableAddonOrdersV2 = useFlag(FLAGS.ENABLE_ADDON_ORDERS_V2);
  const [, setSearchParams] = useSearchParamState();
  const { data: taskTypes } = useAllTaskTypes();

  const addonOrderId = useMemo(
    () => taskTypes?.find(({ name }) => name === TaskTypeNames.ADDON_ORDER)?.id,
    [taskTypes]
  );

  const handleResult = (result: ExtractedArticleInformationType) => {
    if (type === undefined || type === "global") {
      navigate(`/product/ART${result.articleNumber}`);
    } else if (type === "addon" && enableAddonOrdersV2 && addonOrderId) {
      setSearchParams((prev) => {
        prev.set("taskCreator", String(addonOrderId));
        prev.set(
          "initialValues",
          JSON.stringify({
            details: {
              item: {
                no: result.articleNumber,
                type: "ART",
              },
            },
          })
        );
      });
    } else {
      navigate(`/task/new/${type}`, {
        state: {
          product: {
            supplierNumber: result.supplierNumber,
            product: result.articleNumber,
            type: "ART",
          },
        },
      });
    }
  };

  return (
    <>
      <DefaultScannerComponentCameraControlled
        onResult={handleResult}
        withSearchPadding
        shouldShowLargeReadyToScan
      />
      {type === "addon" && <CreateMoreAddonOrdersModal />}
    </>
  );
};

export default DefaultScannerPage;
